import { parseMessageData } from "@/lib/utils/parse-message-data";

const FEEDBACK_KIND = "training_simulator_feedback";
const QUESTION_KIND = "training_simulator_question";

export type TrainingSimulatorTag =
  | { kind: "feedback" }
  | {
      kind: "question";
      modulePosition: number | null;
      levelPosition: number | null;
    };

interface TrainingSimulatorMessageData {
  kind?: string;
  module_position?: number | null;
  level_position?: number | null;
}

export function resolveTrainingSimulatorTag(
  data: string | null | undefined,
): TrainingSimulatorTag | null {
  const parsed = parseMessageData<TrainingSimulatorMessageData>(
    data ?? undefined,
  );

  switch (parsed?.kind) {
    case FEEDBACK_KIND:
      return { kind: "feedback" };
    case QUESTION_KIND:
      return {
        kind: "question",
        modulePosition: parsed.module_position ?? null,
        levelPosition: parsed.level_position ?? null,
      };
    default:
      return null;
  }
}
